import { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { setProgress } from "../redux/slice/system";
import { useWindowResize, useExportExcel } from "../components/hooks";

import { classNames } from "primereact/utils";

export default function ModuleSectionBlock({
  targetId,
  isFullHeight = false, // 是否長滿高度
  isHead = true, // 是否呈現標題
  isExpand = false, // 伸縮控制
  isExport = false, // 是否下載
  exportOptions = [], // 下載設定
  className,
  style = {},
  innerClassName = "", // min-w-30rem
  title,
  overlaySetting = [],
  headTemplate = null,
  bodyTemplate = null,
}) {
  const dispatch = useDispatch();
  const { screenOptions } = useWindowResize({
    targetId,
  });
  const [expand, setExpand] = useState(true);
  const [opShow, setOpShow] = useState(false);
  const [opIndex, setOpIndex] = useState(null);
  const { exportExcel } = useExportExcel({
    action: {
      finish: () => dispatch(setProgress(false)),
    },
  });

  const exportHandler = () => {
    dispatch(setProgress(true));

    exportExcel({ workbookName: title, sheetOptions: exportOptions });
  };

  return (
    <div
      className={classNames("relative flex flex-column w-full", className, {
        "h-full": isFullHeight,
      })}
      style={style}
    >
      {isHead && (
        <div className="flex align-items-center flex-shrink-0 h-3rem text-white bg-dark border-1 border-dark p-2">
          <span>{title}</span>
          <span className="flex-auto"></span>
          {headTemplate}
          {overlaySetting.map((item, index) => (
            <button
              key={`overlay_${item.icon ?? index}`}
              type="button"
              className={classNames(
                "flex align-items-center justify-content-center w-2rem h-2rem border-circle hover:text-main hover:bg-white cursor-pointer p-1 ml-1 transition-ease-in-out-200 border-none",
                {
                  "text-main bg-white": index === opIndex,
                },
              )}
              onClick={() => {
                setOpIndex(opShow ? null : index);
                setOpShow((state) => !state);
              }}
            >
              <i
                className={classNames({
                  [item.icon]: !opShow,
                  "pi pi-times": opShow && opIndex === index,
                })}
              ></i>
            </button>
          ))}
          {isExport && (
            <button
              type="button"
              className="flex align-items-center justify-content-center w-2rem h-2rem border-circle hover:text-main hover:bg-white cursor-pointer p-1 ml-1 transition-ease-in-out-200 border-none"
              onClick={exportHandler}
            >
              <i className="pi pi-download"></i>
            </button>
          )}
          {isExpand && (
            <button
              type="button"
              className="flex align-items-center justify-content-center w-2rem h-2rem border-circle hover:text-main hover:bg-white cursor-pointer p-1 ml-1 transition-ease-in-out-200 border-none"
              onClick={() => setExpand(!expand)}
            >
              <i
                className={classNames("pi", {
                  "pi-angle-up": expand,
                  "pi-angle-down": !expand,
                })}
              ></i>
            </button>
          )}
        </div>
      )}
      <div
        id={targetId}
        className={classNames(
          "relative bg-dark-d border-1 border-dark overflow-y-hidden",
          {
            "h-0rem": !expand,
            "h-full overflow-x-auto": expand,
            "flex-auto": isFullHeight,
          },
        )}
      >
        {opShow && opIndex !== null && (
          <div className="absolute top-0 left-0 w-full bg-dark-l border-bottom-1 border-dark p-1 mb-2 z-1">
            {overlaySetting[opIndex].template}
          </div>
        )}

        <div
          className={classNames("w-full", innerClassName)}
          style={
            isFullHeight
              ? {
                  height: screenOptions.height,
                  maxHeight: screenOptions.height,
                  minHeight: "25vh",
                }
              : {}
          }
        >
          {renderBodyTemplate({ bodyTemplate, screenOptions })}
        </div>
      </div>
    </div>
  );
}

function renderBodyTemplate({ bodyTemplate, screenOptions }) {
  if (!bodyTemplate) {
    return <div className="text-center text-red-600 font-bold">無資料</div>;
  }
  if (typeof bodyTemplate === "function")
    return bodyTemplate({ screenOptions });
  return bodyTemplate;
}

ModuleSectionBlock.propTypes = {
  targetId: PropTypes.string,
  isFullHeight: PropTypes.bool,
  isHead: PropTypes.bool,
  isExpand: PropTypes.bool,
  isExport: PropTypes.bool,
  exportOptions: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
  style: PropTypes.object,
  innerClassName: PropTypes.string,
  title: PropTypes.string,
  overlaySetting: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      template: PropTypes.node,
    }),
  ),
  headTemplate: PropTypes.node,
  bodyTemplate: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};
